export default __webpack_public_path__ + "static/media/People.986e5347.png";